<div class="rl-page lm-page">

  <!-- ── Page Header ──────────────────────────────────── -->
  <div class="lm-page-header">
    <button class="lm-back-btn" (click)="navigateBack()" [title]="'leave_management.gift_of_time_page.title.back' | transloco">
      <mat-icon>{{ 'leave_management.gift_of_time_page.arrow_back' | transloco }}</mat-icon>
    </button>
    <span class="lm-page-title">{{ 'leave_management.gift_of_time_page.gift_of_time' | transloco }}</span>
  </div>

  <lm-loading-overlay [show]="isLoading" message="Loading..."></lm-loading-overlay>
  <lm-loading-overlay [show]="isSubmitting" message="Sending..."></lm-loading-overlay>

  <!-- ── Main Card ───────────────────────────────────── -->
  <div class="lm-card rl-card">
    <div class="rl-layout">

      <!-- ════════════════ LEFT SECTION ════════════════ -->
      <div class="rl-left">

        <form [formGroup]="giftForm" class="rl-form">

          <!-- Leave Type -->
          <div class="lm-form-group">
            <label class="lm-field-label">Choose leave type <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput
                     #leaveTypeInput
                     [formControl]="leaveTypeSearchCtrl"
                     [matAutocomplete]="leaveTypeAuto"
                     [placeholder]="'leave_management.gift_of_time_page.placeholder.search_or_select_leave_type' | transloco"
                     autocomplete="off">
              <button mat-icon-button matSuffix type="button"
                      (click)="toggleLeaveTypePanel($event)"
                      tabindex="-1">
                <mat-icon>{{ 'leave_management.gift_of_time_page.arrow_drop_down' | transloco }}</mat-icon>
              </button>
              <mat-autocomplete #leaveTypeAuto="matAutocomplete"
                                (optionSelected)="onLeaveTypeSelected($event)">
                @for (type of filteredLeaveTypes; track type.id) {
                <mat-option [value]="type.id">
                  {{ type.name }}
                </mat-option>
                }
                @if (filteredLeaveTypes.length === 0) {
                <mat-option disabled>
                  {{ 'leave_management.gift_of_time_page.no_results' | transloco }}
                </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- Balance Banner -->
          @if (selectedLeaveTypeName) {
          <div class="got-balance-banner">
            Available {{ selectedLeaveTypeName }} Balance: {{ leaveBalance }}
          </div>
          }

          <!-- Total Days -->
          <div class="lm-form-group">
            <label class="lm-field-label">Total no of days to be gifted <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput type="number" formControlName="days" min="1">
            </mat-form-field>
          </div>

          <!-- Gift Time To (multi-select) -->
          <div class="lm-form-group">
            <label class="lm-field-label">Gift time to <span class="lm-req">*</span></label>
            <lib-ers-searchable-select
              formControlName="recipientEmployeeIds"
              [options]="recipients"
              optionValue="id"
              optionLabel="name"
              emptyOptionLabel="{{ 'leave_management.gift_of_time_page.select' | transloco }}"
              (selectionChange)="onRecipientChange($event.value)"
            ></lib-ers-searchable-select>
            @if (selectedRecipients.length > 0) {
            <div class="lm-chip-row">
              @for (r of selectedRecipients; track r.id) {
              <span class="lm-chip">
                {{ r.name }}
                <button class="lm-chip-x" (click)="removeRecipient(r.id)" type="button">×</button>
              </span>
              }
            </div>
            }
          </div>

          <!-- Description -->
          <div class="lm-form-group">
            <label class="lm-field-label">{{ 'leave_management.gift_of_time_page.description' | transloco }}</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <textarea matInput formControlName="reason" rows="4"
                        [placeholder]="'leave_management.gift_of_time_page.placeholder.optional_description' | transloco"></textarea>
            </mat-form-field>
          </div>

        </form>

        <!-- Footer Buttons -->
        <div class="rl-form-footer">
          <button class="lm-btn lm-btn--reset" type="button" (click)="onReset()">{{ 'leave_management.gift_of_time_page.reset' | transloco }}</button>
          <button class="lm-btn lm-btn--primary" type="button" (click)="onSend()" [disabled]="isSubmitting">
            @if (isSubmitting) { <span class="lm-btn-spinner"></span> }
            {{ isSubmitting ? 'Sending...' : 'Send' }}
          </button>
        </div>

      </div>

      <!-- ════════════════ RIGHT SECTION ════════════════ -->
      <ers-leave-holiday-panel
        [companyHolidayRows]="companyHolidayRows"
        [optionalHolidayRows]="optionalHolidayRows"
        [pendingWorkedRows]="pendingWorkedRows"
        [holidayColDefs]="holidayColDefs"
        [workedDateColDefs]="workedDateColDefs">
      </ers-leave-holiday-panel>
    </div>
  </div>
</div>
